import { render, staticRenderFns } from "./talk_dinggao.vue?vue&type=template&id=721e392a&scoped=true&"
import script from "./talk_dinggao.vue?vue&type=script&lang=js&"
export * from "./talk_dinggao.vue?vue&type=script&lang=js&"
import style0 from "./talk_dinggao.vue?vue&type=style&index=0&id=721e392a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721e392a",
  null
  
)

export default component.exports